'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'poo';
var width = 512;
var height = 512;
var aliases = [128169];
var unicode = 'f2fe';
var svgPathData = 'M224 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l5.8 5.8c8.7 8.7 13.5 20.4 13.5 32.7l0 8.9c0 20.6-16.7 37.3-37.3 37.3L176 112c-48.6 0-88 39.4-88 88 0 7.2 .9 14.3 2.5 21.1-34.1 12.1-58.5 44.7-58.5 82.9 0 16 4.3 31 11.7 43.9-26.2 15.3-43.7 43.6-43.7 76.1 0 48.6 39.4 88 88 88l336 0c48.6 0 88-39.4 88-88 0-32.5-17.6-60.8-43.7-76.1 7.5-12.9 11.7-27.9 11.7-43.9 0-38.3-24.4-70.8-58.5-82.9 1.7-6.8 2.5-13.8 2.5-21.1 0-35-20.4-65.1-49.9-79.3-11.2-68.4-70.5-120.7-142.1-120.7l-8 0zm40 65.8c0-10.7-2.2-21.2-6.3-30.8 46.1 10.8 81.3 50.2 85.8 98.4 .6 6.3 4.8 11.6 10.7 13.6 22 7.6 37.8 28.4 37.8 53 0 9.1-2.2 17.7-6 25.2-2.4 4.7-2.3 10.2 .2 14.8s7.1 7.7 12.3 8.3c27.9 3.2 49.5 26.9 49.5 55.6 0 15.3-6.2 29.2-16.2 39.4-4 4-5.5 9.9-4.1 15.4s5.7 9.8 11.2 11.3c23.7 6.5 41 28.3 41 54 0 30.9-25.1 56-56 56L88 480c-30.9 0-56-25.1-56-56 0-25.7 17.4-47.4 41-54 5.5-1.5 9.7-5.8 11.2-11.3s-.1-11.3-4.1-15.4c-10-10.1-16.2-24-16.2-39.4 0-28.7 21.7-52.4 49.5-55.6 5.2-.6 9.8-3.7 12.3-8.3s2.6-10.1 .2-14.8c-3.8-7.6-6-16.1-6-25.2 0-30.9 25.1-56 56-56l18.7 0C233 144 264 113 264 74.7l0-8.9zM192 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM172.3 352c-15.6 0-28.3 12.7-28.3 28.3 0 5.5 1.6 11.5 5.6 16.6 9.4 12 44.8 51.1 106.4 51.1s97-39.2 106.4-51.1c4-5.1 5.6-11.1 5.6-16.6 0-15.6-12.7-28.3-28.3-28.3l-167.4 0zM256 416c-38.2 0-63.3-19.8-75.1-32l150.3 0c-11.8 12.2-36.9 32-75.1 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPoo = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;